import { Autocomplete, Checkbox, FormControlLabel, FormGroup, TextField } from "@mui/material";
import React, { useContext, useMemo } from "react";
import { DocumentDetailContext } from "../contexts/DocumentDetailContext";
import "./Classification.css";

const confidenceColorValues = {
    "high": {
        backgroundColor: "rgba(9, 146, 80, 0.2)",
        color: "rgb(9, 146, 80)",
        label: "High Confidence"
    },
    "medium": {
        backgroundColor: "rgba(242, 153, 74, 0.2)",
        color: "rgb(242, 153, 74)",
        label: "Medium Confidence"
    },
    "low": {
        backgroundColor: "rgba(235, 87, 87, 0.2)",
        color: "rgb(235, 87, 87)",
        label: "Low Confidence"
    },

}
const Classification = (props) => {

    const { setDocumentData, data = {}, duplicateDocumentView, classificationMappingData = {}, setDataSave } = useContext(DocumentDetailContext);

    const confidenceDetails = useMemo(() => {
        let confidence = (data.Entity_Details.classifyConfidence * 100).toFixed(2);
        let range = "";
        if (confidence >= 80) {
            range = "high";
        } else if (confidence < 80 && confidence >= 50) {
            range = "medium";
        } else {
            range = "low";
        }

        if(data.Entity_Details.classify.documentSubCategory == "External Result") {
            return {
                ...confidenceColorValues["low"],
                label: "High Confidence",
                confidence
            }
        }

        return {
            ...confidenceColorValues[range],
            confidence,
        }
    }, [data]);

    const mapCategory = (sub_category) => {
        var sub_category_val = sub_category ? sub_category : data.Entity_Details.classify
            .documentSubCategory;
        return {
            docClassification: classificationMappingData[sub_category_val]?.category.display_name,
            documentSubCategory: sub_category_val,
            documentLevel: classificationMappingData[sub_category_val]?.doc_level.display_name
        };
    };

    const getSubCategoryOptions = (list) => {
        let optionArray = Object.keys(list || {}).map(m => {
            return {
                label: m,
                id: m,
                disable: m == "Pharmacy Documentation" ? data.location != "MTM Value Based" : !list[m]?.enabled
            }
        });
        let enabledOptions = optionArray.filter(m => !m.disable);
        let disabledOptions = optionArray.filter(m => m.disable);
        return [...enabledOptions, ...disabledOptions]
    }

    const handleCategory = (sub_category, reason) => {
        if (reason != "selectOption") {
            return 0;
        }
        let classify = mapCategory(sub_category);
        data.Entity_Details.classify = { ...data.Entity_Details.classify, ...classify }
        data.Entity_Details.classModify = true;
        data.Entity_Details.classifyConfidence = 1;
        setDocumentData({ ...data });
        setDataSave(true);
    }

    return <div className="category-display">
        <div
            className={data.Entity_Details.classModify ? "card-flag" : "card-flag-hide"}
        >
            <div className="tri-flag" />
        </div>
        <div className="each-category" style={{ width: "30%" }}>
            <div className="icon-text">
                <div className="label-font" style={{ marginTop: "0px", marginRight: "15px" }}>
                    Category
                </div>
            </div>
            <div className="value-font">{data?.Entity_Details?.classify?.docClassification || ""}</div>
        </div>
        <div className="each-category" style={{ width: "70%" }}>
            <div style={{ display: "flex", justifyContent: "space-between", width: "stretch" }}>
                <div className="label-font" style={{ marginTop: "0px", }}>
                    Sub-Category
                </div>
                <div className="confidence-container" style={{ marginBottom: "5px", alignItems: "center", padding: "2px 10px", backgroundColor: confidenceDetails.backgroundColor, color: confidenceDetails.color, border: `1px solid #dedede`, borderRadius: "5px" }}>
                    <span style={{fontSize: "12px", fontWeight: 700, paddingRight: "10px" }}>{confidenceDetails.label}</span> <span style={{opacity: 0.4}}>|</span><span style={{fontSize: "12px", fontWeight: 900, paddingLeft: "10px" }}>{confidenceDetails.confidence}%</span>
                </div>
            </div>
            {<Autocomplete
                onClose={(event, reason) => {
                    if (reason === "blur" || reason === "escape") return;
                }}
                disableCloseOnBlur
                options={getSubCategoryOptions(classificationMappingData)}
                name="subCategory"
                disabled={duplicateDocumentView}
                value={data?.Entity_Details?.classify?.documentSubCategory || ""}
                onChange={(event, newValue, reason) =>
                    handleCategory(newValue?.label, reason)
                }
                getOptionDisabled={(option) => option?.disable}
                sx={{
                    width: "100%",
                    "& :before": {
                        borderColor: "var(--border-dark)"
                    },
                    "input": {
                        color: "var(--text-primary)"
                    }
                }}
                renderInput={(params) => (
                    <TextField {...params} variant="standard" label="" />
                )}
            />}
        </div>
    </div>
}

export default Classification;